import { render, staticRenderFns } from "./TransferCp.vue?vue&type=template&id=48495f3c&scoped=true&"
import script from "./TransferCp.vue?vue&type=script&lang=js&"
export * from "./TransferCp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48495f3c",
  null
  
)

export default component.exports